import AuthorizationAction from "../actiontype/authorization.actiontype";
import AuthorizationStatus from "../constants/authorization-status.enum";
import AuthorizationActionType from "../actiontype/authorization.actiontype";

const initialState = {
    authStatus: AuthorizationStatus.UNAUTHORIZED,
    requestKey: '',
    loggedInNumber: '',
    selectedNumber: '',
    mobileAppAuthToken: null
}

export default function AuthorizationReducer(state = initialState, action) {

    switch (action.type) {
        case AuthorizationActionType.USER_AUTHORIZED:
            return {
                ...state,
                authStatus: AuthorizationStatus.AUTHORIZED
            }
        case AuthorizationAction.USER_UNAUTHORIZED:
            return {
                ...state,
                authStatus: AuthorizationStatus.UNAUTHORIZED
            }
        case AuthorizationAction.CHECK_AUTH_TOKEN_LOADING:
            return {
                ...state,
                authStatus: AuthorizationStatus.LOADING
            }
        case AuthorizationActionType.SET_REQUEST_KEY:
            return {
                ...state,
                requestKey: action.payload
            }
        case AuthorizationActionType.SET_LOGGEDIN_MOBILE_NUMBER:
            return {
                ...state,
                loggedInNumber: action.payload
            }
        case AuthorizationActionType.SET_SELECTED_NUMBER:
            return {
                ...state,
                selectedNumber: action.payload
            }
        case AuthorizationActionType.SET_MOBILE_APP_AUTH_TOKEN:
            return {
                ...state,
                mobileAppAuthToken: action.payload
            }
        default:
    }

    return state;
}